import { styled, Typography } from '@mui/material';
import { Row } from 'components/Layout';

type Props = {
  label: string;
  index: number;
};

const Item = styled(Row)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: theme.spacing(2),
  borderRadius: theme.shape.borderRadius,
  backgroundColor: 'transparent',
  borderBottom: `1px solid ${theme.palette.divider}`,
  fontWeight: theme.typography.fontWeightBold,
  color: theme.palette.text.secondary,
}));

const FixedWaterfallStructureItem: React.FC<Props> = ({ label, index }) => {
  return (
    <Row centered justify="space-between" spacing="sm">
      <Typography variant="body2" fontWeight={700} color="text.secondary">
        {index + 1}
      </Typography>
      <Item centered justify="space-between" fullWidth>
        {label}
      </Item>
    </Row>
  );
};

export default FixedWaterfallStructureItem;
